import { motion } from 'framer-motion';

export default function AboutSection() {
  const timeline = [
    { type: 'past', text: '공군 학사장교 80기 (중위 만기전역)' },
    { type: 'past', text: '한국도로공사(서해안고속도로, 도로연구소)' },
    { type: 'past', text: '신성대학교 교수 (24년근무)' },
    { type: 'past', text: '㈜씨이비 대표 (건설/환경신기술 컨설팅)' },
    { type: 'current', text: '한창안전 기술사사무소 대표' },
    { type: 'current', text: '주식회사 더불어안전 대표이사' },
    { type: 'current', text: '신성대학교 명예교수' },
  ];

  const qualifications = [
    '신성대학교 명예교수',
    '공학박사(토목구조)',
    '건설안전기술사',
    '산업안전지도사 (건설)',
    '국제기술사(건설공학)',
  ];

  return (
    <section id="about" className="py-16 sm:py-24 lg:py-32 bg-white">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="text-[#ff6b35] text-xs font-semibold tracking-[0.2em] mb-2 sm:mb-3">
            ABOUT US
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1a2b4a] mb-2">
            기업 및 대표이사 소개
          </h2>
          <div className="w-16 sm:w-20 h-1 bg-[#ff6b35] mb-10 sm:mb-16"></div>
        </motion.div>

        {/* Content Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-12">
          {/* Left: Profile Card */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="lg:col-span-2"
          >
            <div className="bg-[#f8f9fa] rounded-2xl sm:rounded-3xl p-6 sm:p-10">
              <div className="flex justify-center mb-5 sm:mb-6">
                <div className="w-32 h-32 sm:w-44 sm:h-44 rounded-full bg-gradient-to-br from-[#ff6b35] to-[#ff8c5a] flex items-center justify-center">
                  <img
                    src="https://static.readdy.ai/image/78632d8b956292c6b7fad4ff0ca846be/62cd3db99b8883a7127dea6c7e6ef200.jpeg"
                    alt="대표이사"
                    className="w-28 h-28 sm:w-40 sm:h-40 rounded-full object-cover"
                  />
                </div>
              </div>
              <div className="text-center mb-5 sm:mb-6">
                <h3 className="text-2xl sm:text-3xl font-bold text-[#1a2b4a] mb-2">
                  고 영 주 대표이사
                </h3>
              </div>

              <div className="border-t border-gray-300 my-5 sm:my-6"></div>

              <div className="space-y-3 sm:space-y-4 mb-5 sm:mb-6">
                <h4 className="text-base sm:text-lg font-bold text-[#1a2b4a] mb-3 sm:mb-4">
                  주요 자격
                </h4>
                {qualifications.map((qual, index) => (
                  <div key={index} className="flex items-start gap-2 sm:gap-3">
                    <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                      <i className="ri-checkbox-circle-fill text-[#ff6b35] text-base sm:text-lg"></i>
                    </div>
                    <span className="text-sm text-gray-700 leading-relaxed">{qual}</span>
                  </div>
                ))}
              </div>

              <div className="border-t border-gray-300 my-5 sm:my-6"></div>

              <div className="bg-white rounded-xl p-4 sm:p-5 flex items-center gap-3 sm:gap-4">
                <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full flex items-center justify-center flex-shrink-0 overflow-hidden">
                  <img
                    src="https://public.readdy.ai/ai/img_res/f49e112bf724ee97c7f0c8aa1a235a71.jpg"
                    alt="대한민국 태극문양"
                    className="w-full h-full object-contain"
                  />
                </div>
                <div>
                  <div className="text-xs text-gray-500 mb-0.5 sm:mb-1">상훈</div>
                  <div className="text-sm font-bold text-[#1a2b4a]">대한민국 근정포장</div>
                  <div className="text-xs text-gray-600">제129292호, 2022.5.15</div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Right: Timeline & Vision */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="lg:col-span-3"
          >
            {/* Timeline */}
            <div className="mb-8 sm:mb-12">
              <h4 className="text-xl sm:text-2xl font-bold text-[#1a2b4a] mb-6 sm:mb-8">
                대표이사 약력
              </h4>
              <div className="space-y-4 sm:space-y-5">
                {timeline.map((item, index) => (
                  <div key={index} className="flex items-start gap-2 sm:gap-3">
                    <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                      <i className={`ri-checkbox-circle-fill text-base sm:text-lg ${item.type === 'current' ? 'text-[#ff6b35]' : 'text-gray-400'}`}></i>
                    </div>
                    <div
                      className={`text-sm sm:text-base ${
                        item.type === 'current'
                          ? 'text-[#1a2b4a] font-bold'
                          : 'text-gray-600'
                      }`}
                    >
                      <span
                        className={`${
                          item.type === 'current' ? 'text-[#ff6b35]' : 'text-gray-500'
                        } font-semibold mr-2`}
                      >
                        {item.type === 'current' ? '현)' : '전)'}
                      </span>
                      {item.text}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Vision & Mission Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
              <div className="bg-[#1a2b4a] rounded-xl sm:rounded-2xl p-6 sm:p-8 text-white">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#ff6b35] rounded-full flex items-center justify-center mb-3 sm:mb-4">
                  <i className="ri-focus-3-line text-white text-lg sm:text-xl"></i>
                </div>
                <div className="text-xs text-[#ff6b35] font-semibold tracking-wider mb-2 sm:mb-3">
                  VISION
                </div>
                <div className="text-sm sm:text-base leading-relaxed">
                  "국내 최고 수준의 건설안전컨설팅 및 재해예방기술지도 전문기관"
                  <br />
                  <br />
                  "중소규모 건설 재해예방의 선도적 역할"
                  <br />
                  <br />
                  "건설현장의 안전문화 정착"
                </div>
              </div>

              <div className="bg-[#ff6b35] rounded-xl sm:rounded-2xl p-6 sm:p-8 text-white">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-white rounded-full flex items-center justify-center mb-3 sm:mb-4">
                  <i className="ri-rocket-line text-[#ff6b35] text-lg sm:text-xl"></i>
                </div>
                <div className="text-xs text-white font-semibold tracking-wider mb-2 sm:mb-3">
                  MISSION
                </div>
                <div className="text-sm sm:text-base leading-relaxed">
                  현장중심의 실효성 있는 재해예방기술지도 /
                  <br />
                  안전관리 솔루션 제공
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
